export default __webpack_public_path__ + "static/Logo_TaxDashs-cff25ee4100c426ea98743fddef1595c.png";